module.exports = __webpack_public_path__ + "img/home-dog-2.f326de9f.jpg";